const convertTagsToSlugs = (tags) => (tags.map((tag) => tag.slug))


const sortTags = (tagsToSort) => ([...tagsToSort].sort((a, b) => {
  if (a.sortIndex > b.sortIndex) {
    return 1
  }
  if (b.sortIndex > a.sortIndex) {
    return -1
  }
  return 0
}))

const generateUrlFromState = (state) => {
  const { search } = window.location
  const { basePageUrl } = window
  let { virtualSlug } = window
  const { facetSlug, tags: selectedTags } = state

  if (virtualSlug && (selectedTags.length || facetSlug)) {
    virtualSlug = `${virtualSlug}/`
  } else {
    virtualSlug = ''
  }

  let url = ''
  if (facetSlug) {
    url = `${basePageUrl}${virtualSlug}${facetSlug}/`
  } else {
    const sortedTags = sortTags(state.tags)
    const slugifiedTags = convertTagsToSlugs(sortedTags)
    const tags = slugifiedTags.length ? `${slugifiedTags.join('/')}/` : ''
    url = `${basePageUrl}${virtualSlug}${tags}`
  }

  const queryParams = new URLSearchParams(search)

  if (state.searchTerms.length) {
    queryParams.set('search', state.searchTerms.join('+'))
  } else {
    queryParams.delete('search')
  }

  // SEO requirement
  if (facetSlug || state.searchTerms.length) {
    queryParams.delete('skip')
  }

  const queryString = queryParams.toString()
  if (queryString) {
    url += `?${queryString}`
  }
  return url
}

export default {
  save: (state) => {
    const url = generateUrlFromState(state)
    window.history.pushState(state, '', url)
  },
  replace: (state) => {
    const url = generateUrlFromState(state)
    window.history.replaceState(state, '', url)
  },
  reload: () => {
    window.location = window.basePageUrl
  },
  openRecipe: (state) => {
    window.location = generateUrlFromState(state)
  }
}
